import TransportDetailController from './transport.detail.controller';

export default {
    template: require('./transport.detail.html'),
    controller: TransportDetailController
};
